import React, { useEffect } from "react";
import { connect } from "react-redux";

import { bindActionCreators, Dispatch } from "redux";

import { DataColumnDef, DataTableDef, Overlay } from "@plex/react-components";

import { INotification } from "infrastructure/notification";
import { Banner } from "ui/app/common";
import { useLocalizedValues } from "ui/hooks";
import { displayMessages } from "ui/screens/translation-managers";

import { messageTranslationsActions } from "./MessageTranslations.actions";
import { IMessageTranslation, IMessageTranslationState } from "./MessageTranslations.state";

interface IMessageTranslationsProps {
  messageId: string;
  translations: IMessageTranslation[];
  notifications: INotification[];
  isLoading: boolean;
  loadMessageTranslations: (messageId: string) => void;
}

const MessageTranslations: React.FC<IMessageTranslationsProps> = ({ messageId, translations, notifications, isLoading, loadMessageTranslations }) => {
  const localizedValues = useLocalizedValues(() => ({
    localeTitle: displayMessages.property("locale"),
    industryTitle: displayMessages.property("industry"),
    textTitle: displayMessages.property("text")
  }));

  useEffect(() => {
    loadMessageTranslations(messageId);
  }, [messageId, loadMessageTranslations]);

  const renderGrid = (
    <DataTableDef<IMessageTranslation> data={translations} keySelector={(item: IMessageTranslation) => item.text}>
      <DataColumnDef id="locale" title={localizedValues.localeTitle}>
        {(item: IMessageTranslation) => item.language}
      </DataColumnDef>
      <DataColumnDef id="industry" title={localizedValues.industryTitle}>
        {(item: IMessageTranslation) => item.industryDescription}
      </DataColumnDef>
      <DataColumnDef id="text" title={localizedValues.textTitle}>
        {(item: IMessageTranslation) => item.text}
      </DataColumnDef>
    </DataTableDef>
  );

  return (
    <>
      <Overlay show={isLoading} showSpinner />
      <Banner messages={notifications} />
      {translations.length > 0 && renderGrid}
    </>
  );
};

export default connect(
  (state: { messageTranslations: IMessageTranslationState }) => {
    return {
      translations: state.messageTranslations.messageTranslations,
      notifications: state.messageTranslations.notifications,
      isLoading: state.messageTranslations.isLoading
    };
  },
  (dispatch: Dispatch) =>
    bindActionCreators(
      {
        loadMessageTranslations: messageTranslationsActions.loadMessageTranslations
      },
      dispatch
    )
)(MessageTranslations);
